import React from 'react';
import { SingleValueEllipse } from 'components/Inputs/Select/customize';

export const EllipseSelection = (props) => <SingleValueEllipse {...props} />;
